module.exports = __webpack_public_path__ + "img/email.ef08eef0.svg";